// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading_nSUks {
  color : var( --color-secondaryBrand700, #1D9A9A );
  font-size : var( --font-size-large );
  position:absolute;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  width : 100%;
  height: 100%;
  top:0;
  left:0;
  background : rgb( 255,255,255,0.6);
  div {
    margin : 10px
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Loading.css"],"names":[],"mappings":"AAEA;EACE,iDAAiD;EACjD,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,KAAK;EACL,MAAM;EACN,kCAAkC;EAClC;IACE;EACF;AACF","sourcesContent":["@import \"../style/theme.css\";\n\n.loading {\n  color : var( --color-secondaryBrand700, #1D9A9A );\n  font-size : var( --font-size-large );\n  position:absolute;\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  width : 100%;\n  height: 100%;\n  top:0;\n  left:0;\n  background : rgb( 255,255,255,0.6);\n  div {\n    margin : 10px\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `loading_nSUks`
};
export default ___CSS_LOADER_EXPORT___;
